<script setup lang="ts">
const t2 = useT2({
  'Size guide': 'Dydžių gidas',
})

defineProps<{
  guideProductId: string | None
  guideBodyId: string | None
  sellerId: string | None
}>()
const init3 = useInited('init3')
const elem = useTemplateRef('elem')
const open = shallowRef(false)
</script>

<template>
  <ButtonInline ref="elem" :txt="undefined" blue :open @click.passive="open = !open">
    <IconInfo class="_svg" />
    <span class="_fs08 _ml06">{{ t2('Size guide') }} </span>

    <template v-if="init3">
      <Teleport to="#teleports">
        <UiDim2 :open :click="() => open = false" zindex="199" />
      </Teleport>

      <UiPreview4 v-model="open" :elem="() => elem" nopad :class-modal="$style.cont">
        <LazySizeGuide4 :guide-product-id :guide-body-id :seller-id />
      </UiPreview4>
    </template>
  </ButtonInline>
</template>

<style module>
.cont {
  border: 1px solid var(--blue3);
  composes: global(_br14);
  composes: global(_hidden);
}
</style>
